import { createEffect, createMemo, createSignal, For, Show } from 'solid-js';

export interface Command {
  id: string;
  label: string;
  hint?: string;
  run: () => void | Promise<void>;
}

interface Props {
  open: boolean;
  commands: Command[];
  onClose: () => void;
}

export function Palette(props: Props) {
  const [q, setQ] = createSignal('');
  const [idx, setIdx] = createSignal(0);
  let inputRef: HTMLInputElement | undefined;

  createEffect(() => {
    if (props.open) {
      setQ('');
      setIdx(0);
      queueMicrotask(() => inputRef?.focus());
    }
  });

  const filtered = createMemo(() => {
    const needle = q().toLowerCase().trim();
    if (!needle) return props.commands;
    return props.commands.filter((c) => c.label.toLowerCase().includes(needle) || c.id.toLowerCase().includes(needle));
  });

  const run = (c: Command) => {
    props.onClose();
    void c.run();
  };

  return (
    <Show when={props.open}>
      <div class="palette-backdrop" onClick={props.onClose}>
        <div class="palette" onClick={(e) => e.stopPropagation()}>
          <input
            ref={inputRef}
            class="palette-input"
            placeholder="Type a command…"
            value={q()}
            onInput={(e) => { setQ(e.currentTarget.value); setIdx(0); }}
            onKeyDown={(e) => {
              const items = filtered();
              if (e.key === 'Escape') props.onClose();
              else if (e.key === 'ArrowDown') { e.preventDefault(); setIdx(Math.min(idx() + 1, items.length - 1)); }
              else if (e.key === 'ArrowUp') { e.preventDefault(); setIdx(Math.max(0, idx() - 1)); }
              else if (e.key === 'Enter') { e.preventDefault(); const c = items[idx()]; if (c) run(c); }
            }}
          />
          <ul class="palette-list">
            <For each={filtered()}>
              {(c, i) => (
                <li
                  class={i() === idx() ? 'palette-item active' : 'palette-item'}
                  onMouseEnter={() => setIdx(i())}
                  onClick={() => run(c)}
                >
                  <span class="palette-label">{c.label}</span>
                  <Show when={c.hint}><span class="palette-hint">{c.hint}</span></Show>
                </li>
              )}
            </For>
            <Show when={filtered().length === 0}>
              <li class="palette-empty">No matches</li>
            </Show>
          </ul>
        </div>
      </div>
    </Show>
  );
}
